import { Box, Card, CardMedia, useTheme } from "@mui/material";
import { useStatusStore } from "../../stores/statusStore/useStatusStore";
import { Yantra } from "../../tanstack/queries/player";

interface IProps {
  card: Yantra;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  isActive: boolean;
  count: number;
  isRow: boolean;
  borderColor: string;
}

function YantraSingleCard({ card, onClick, isActive, count, isRow, borderColor }: IProps) {
  const { image } = card;
  const { isDisabled } = useStatusStore();
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        transition: "all .3s",
        borderRadius: theme.spacing(3),
        width: "100%",
        "@media (hover: hover) and (pointer: fine)": {
          "&:hover": {
            transform: isDisabled ? null : "translateY(-0.25rem)",
            filter: isDisabled ? null : "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.5))",
          },
        },
      }}
    >
      {isActive && !isRow && (
        <Box
          sx={{
            width: { xs: theme.spacing(2.5), md: theme.spacing(5) },
            aspectRatio: "17 / 19",
            bgcolor: "#556bd6",
            color: "white",
            fontSize: {
              xs: theme.typography.pxToRem(12),
              md: theme.typography.pxToRem(24),
            },
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            position: "absolute",
            top: theme.spacing(-1),
            right: theme.spacing(-1.5),
            zIndex: 5,
          }}
        >
          {count}
        </Box>
      )}

      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          p: 0,
          borderRadius: 3,
          border: `3px solid color-mix(in srgb, ${borderColor} 55%, black)`,
          width: "100%",
          position: "relative",
          zIndex: 2,
          cursor: "pointer",
          transition: "all .3s",
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            width: "100%",
            height: "100%",
          }}
        />
        <CardMedia
          sx={{
            width: "100%",
            aspectRatio: "17 / 19",
            objectFit: "cover",
            borderRadius: 1.5,
            filter: isDisabled ? "grayscale(1)" : "grayscale(0)",
          }}
          image={image}
          title={image}
        />
      </Card>
    </Box>
  );
}

export default YantraSingleCard;
